import React from "react";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import { organisationStore } from "features/Organisation/OrganisationStore";
import { buildingSettingsStore } from "./BuildingSettings/BuildingSettingsStore";
import { conformityStore } from "../../store/ConformityStore.ts";

export function useBuildings() {
  const { currentBuilding } = buildingStore;
  const { id: buildingID } = useParams();

  React.useEffect(() => {
    buildingStore.setBuildingID(buildingID);
  }, [buildingID]);

  React.useEffect(() => {
    conformityStore.fetchCertificationData();
  }, []);

  React.useEffect(() => {
    if (!buildingSettingsStore.buildingAlreadyUpdated) return;
    const timer = setTimeout(() => {
      buildingSettingsStore.setBuildingAlreadyUpdated(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [buildingSettingsStore.buildingAlreadyUpdated]);

  async function refreshOnChangeBuilding() {
    if (!currentBuilding) return;
    if (organisationStore.organisations.items.length === 0) {
      await organisationStore.getAllOrganisations();
    }
    !buildingStore.sourceFiles.loading &&
      buildingStore.setSourceFiles({
        ...buildingStore.sourceFiles,
        loading: true,
      });
    buildingStore.resetBuildingMappingStatus();
    await buildingStore.getAllSourceFiles();
    await buildingStore.getBuildingMappingStatus();
  }

  return {
    refreshOnChangeBuilding,
  };
}
